import { atom } from 'jotai';
import { PaginatedAdoptionReports } from '../types/adoptionReports';

// Create atoms for storing adoption report data
export const adoptionReportsAtom = atom<PaginatedAdoptionReports | null>(null);
